/*
 * olv-cart-remove-at-min.js
 * ─────────────────────────
 * Impact-quantity-selector im Cart-Kontext so patchen, dass ein Klick
 * auf „–" bei Menge == min die Position entfernt (POST /cart/change.js
 * mit quantity:0) statt still no-op zu bleiben (HTML5 stepDown()
 * respektiert min → Bug im Warenkorb).
 *
 * Nur im Cart-Kontext (Element steckt in <line-item>). Auf der PDP
 * bleibt „–" bei Menge 1 stehen — dort gibt es keinen <line-item>-
 * Wrapper.
 *
 * Kein Edit im Impact-Bundle (theme.js), damit Impact-Refreshes den
 * Fix nicht überschreiben.
 */
(function () {
  'use strict';

  function isCartContext(el) {
    return el.closest('line-item') !== null;
  }

  function patchQuantitySelector() {
    var QS = window.customElements && window.customElements.get('quantity-selector');
    if (!QS || QS.__olvCartMinRemovePatched) return;

    var originalStepDown = QS.prototype.stepDown;

    QS.prototype.stepDown = function () {
      if (!this.inputElement || !isCartContext(this)) {
        return originalStepDown.call(this);
      }

      var current = parseInt(this.inputElement.value, 10);
      /* Rekursionsschutz: nach dem Sprung auf 0 ruft QuantityInput
         intern nochmal stepDown() (checkValidity=false). Hier abbrechen. */
      if (!isFinite(current) || current <= 0) return;

      var min = parseInt(this.inputElement.min, 10);
      if (!isFinite(min) || min < 1) min = 1;

      if (current <= min) {
        this.inputElement.value = '0';
        this.inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      return originalStepDown.call(this);
    };

    QS.__olvCartMinRemovePatched = true;
  }

  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('quantity-selector')
      .then(patchQuantitySelector)
      .catch(function () {});
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchQuantitySelector);
  } else {
    patchQuantitySelector();
  }
})();
